[
  {
    "id": "SUP01",
    "slug": "draft-replies-to-tickets-youve-solved-before",
    "title": "Draft replies to tickets you've solved before",
    "pitch": "When a question has been answered before, get a draft reply from that answer.",
    "team": "Customer support",
    "industries": ["Software", "Any"],
    "trigger": "event",
    "steps": [
      "Read the new ticket",
      "Find matching solved tickets and help articles",
      "Draft a reply",
      "Route the rest to the right person"
    ],
    "example_ask": "Draft replies for new tickets that match past answers.",
    "maito": {
      "connect": [
        {
          "need": "support desk",
          "servers": ["Intercom", "Pylon", "Zoho Desk", "Unthread", "Freshdesk"]
        },
        { "need": "help center", "servers": ["Intercom", "Notion"] }
      ],
      "skill": []
    }
  },
  {
    "id": "SUP02",
    "slug": "spot-recurring-issues-early",
    "title": "Spot recurring issues early",
    "pitch": "Group tickets by cause so a new problem shows up before it's a flood.",
    "team": "Customer support",
    "industries": ["Software", "Any"],
    "trigger": "schedule",
    "steps": [
      "Read the day's tickets",
      "Group them by likely cause",
      "Flag any group that's growing"
    ],
    "example_ask": "Every afternoon, tell me if a new issue is spreading.",
    "maito": {
      "connect": [
        {
          "need": "support desk",
          "servers": ["Intercom", "Pylon", "Zoho Desk", "Unthread", "Freshdesk"]
        }
      ],
      "skill": []
    }
  },
  {
    "id": "SUP03",
    "slug": "daily-escalations-view",
    "title": "Daily escalations view",
    "pitch": "See every escalated or at-risk ticket in one message each morning.",
    "team": "Customer support",
    "industries": ["Software", "Any"],
    "trigger": "schedule",
    "steps": [
      "Find tickets escalated, waiting long, or from key accounts",
      "Say what each needs",
      "Post the list"
    ],
    "example_ask": "Every morning, send me tickets that are at risk.",
    "maito": {
      "connect": [
        {
          "need": "support desk",
          "servers": ["Intercom", "Pylon", "Zoho Desk", "Unthread", "Freshdesk"]
        },
        { "need": "CRM", "servers": ["HubSpot", "Salesforce", "Attio", "Pipedrive"] }
      ],
      "skill": []
    }
  },
  {
    "id": "SUP04",
    "slug": "reproduce-a-bug-from-a-customer-report",
    "title": "Reproduce a bug from a customer report",
    "pitch": "Turn \"it's broken\" into exact steps, a recording and a bug report engineers can use.",
    "team": "Customer support",
    "industries": ["Software", "Any"],
    "trigger": "event",
    "steps": [
      "Read the report",
      "Try to reproduce it in the app",
      "Record what happens",
      "File a bug with steps and video"
    ],
    "example_ask": "Can you reproduce this customer's export bug?",
    "maito": {
      "connect": [{ "need": "issue tracker", "servers": ["Linear", "Jira (Atlassian)", "GitHub"] }],
      "skill": []
    }
  },
  {
    "id": "SUP05",
    "slug": "answer-how-does-this-work-from-the-code",
    "title": "Answer \"how does this work?\" from the code",
    "pitch": "Support gets the real answer from the product, not from an outdated doc.",
    "team": "Customer support",
    "industries": ["Software", "Any"],
    "trigger": "ask",
    "steps": [
      "Read the question",
      "Check docs and the code",
      "Answer with what the product actually does"
    ],
    "example_ask": "Does the API rate limit apply per user or per workspace?",
    "maito": {
      "connect": [{ "need": "docs", "servers": ["Notion", "Confluence (Atlassian)", "Box"] }],
      "skill": []
    }
  },
  {
    "id": "SUP06",
    "slug": "keep-help-articles-current-after-a-release",
    "title": "Keep help articles current after a release",
    "pitch": "After each release, find help articles that no longer match the product and draft fixes.",
    "team": "Customer support",
    "industries": ["Software", "Any"],
    "trigger": "event",
    "steps": [
      "Read what changed in the release",
      "Find articles that mention it",
      "Draft updated text and new screenshots"
    ],
    "example_ask": "After each release, update affected help articles.",
    "maito": {
      "connect": [{ "need": "help center", "servers": ["Intercom", "Notion"] }],
      "skill": []
    }
  },
  {
    "id": "SUP07",
    "slug": "write-a-help-article-from-a-solved-ticket",
    "title": "Write a help article from a solved ticket",
    "pitch": "When an answer took effort, turn it into an article so nobody solves it again.",
    "team": "Customer support",
    "industries": ["Software", "Any"],
    "trigger": "ask",
    "steps": [
      "Read the ticket thread",
      "Write a short article",
      "Suggest where it goes in the help center"
    ],
    "example_ask": "Turn this ticket into a help article.",
    "maito": {
      "connect": [
        {
          "need": "support desk",
          "servers": ["Intercom", "Pylon", "Zoho Desk", "Unthread", "Freshdesk"]
        },
        { "need": "help center", "servers": ["Intercom", "Notion"] }
      ],
      "skill": []
    }
  },
  {
    "id": "SUP08",
    "slug": "summarize-a-long-ticket-for-handoff",
    "title": "Summarize a long ticket for handoff",
    "pitch": "Get the whole story of a messy ticket in five lines before you take it over.",
    "team": "Customer support",
    "industries": ["Software", "Any"],
    "trigger": "ask",
    "steps": ["Read the thread", "Summarize problem, what was tried, and what's next"],
    "example_ask": "Summarize this ticket for me.",
    "maito": {
      "connect": [
        {
          "need": "support desk",
          "servers": ["Intercom", "Pylon", "Zoho Desk", "Unthread", "Freshdesk"]
        }
      ],
      "skill": []
    }
  },
  {
    "id": "SUP09",
    "slug": "turn-customer-feedback-into-product-themes",
    "title": "Turn customer feedback into product themes",
    "pitch": "Each week, see what customers asked for, grouped and counted, with links.",
    "team": "Customer support",
    "industries": ["Software", "Any"],
    "trigger": "schedule",
    "steps": [
      "Read tickets, chats and call notes",
      "Pull out requests and complaints",
      "Group and count",
      "Post to product"
    ],
    "example_ask": "Every Friday, send product the top customer requests.",
    "maito": {
      "connect": [
        {
          "need": "support desk",
          "servers": ["Intercom", "Pylon", "Zoho Desk", "Unthread", "Freshdesk"]
        },
        {
          "need": "call notes",
          "servers": ["Granola", "Fireflies", "Fathom", "Otter.ai", "Read AI", "Zoom"]
        }
      ],
      "skill": []
    }
  },
  {
    "id": "SUP10",
    "slug": "tag-and-route-incoming-tickets",
    "title": "Tag and route incoming tickets",
    "pitch": "Every new ticket gets the right tags, priority and owner.",
    "team": "Customer support",
    "industries": ["Software", "Any"],
    "trigger": "event",
    "steps": ["Read the ticket", "Pick category and priority", "Assign to the right team"],
    "example_ask": "Tag and route new tickets by product area.",
    "maito": {
      "connect": [
        {
          "need": "support desk",
          "servers": ["Intercom", "Pylon", "Zoho Desk", "Unthread", "Freshdesk"]
        }
      ],
      "skill": []
    }
  },
  {
    "id": "SUP11",
    "slug": "draft-customer-updates-during-an-incident",
    "title": "Draft customer updates during an incident",
    "pitch": "Mention Maito in the incident thread and get a status update for customers while engineers keep fixing.",
    "team": "Customer support",
    "industries": ["Software", "Any"],
    "trigger": "ask",
    "steps": [
      "Read the incident thread",
      "Draft a plain update",
      "Suggest a time for the next one"
    ],
    "example_ask": "@Maito draft a status page update from this thread.",
    "maito": {
      "connect": [{ "need": "status page", "servers": ["incident.io", "Better Stack"] }],
      "skill": []
    }
  },
  {
    "id": "SUP12",
    "slug": "find-out-which-customers-a-bug-affects",
    "title": "Find out which customers a bug affects",
    "pitch": "Get the list of affected accounts so you can reach out first.",
    "team": "Customer support",
    "industries": ["Software", "Any"],
    "trigger": "ask",
    "steps": ["Read the bug", "Find accounts using the affected feature", "Draft a heads-up email"],
    "example_ask": "Which customers are hit by the export bug?",
    "maito": {
      "connect": [
        { "need": "database", "servers": ["BigQuery", "Supabase"] },
        { "need": "analytics", "servers": ["Amplitude", "Mixpanel", "PostHog"] },
        { "need": "email", "servers": ["Gmail", "Microsoft 365", "Superhuman Mail"] }
      ],
      "skill": []
    }
  },
  {
    "id": "SUP13",
    "slug": "check-support-answers-for-accuracy",
    "title": "Check support answers for accuracy",
    "pitch": "Review a sample of replies for wrong facts and outdated advice.",
    "team": "Customer support",
    "industries": ["Software", "Any"],
    "trigger": "schedule",
    "steps": [
      "Pick a sample of sent replies",
      "Check facts against docs and product",
      "List mistakes and coaching notes"
    ],
    "example_ask": "Every week, check 30 random support replies.",
    "maito": {
      "connect": [
        {
          "need": "support desk",
          "servers": ["Intercom", "Pylon", "Zoho Desk", "Unthread", "Freshdesk"]
        },
        { "need": "docs", "servers": ["Notion", "Confluence (Atlassian)", "Box"] }
      ],
      "skill": []
    }
  },
  {
    "id": "SUP14",
    "slug": "answer-questions-in-a-shared-customer-slack-channel",
    "title": "Answer questions in a shared customer Slack channel",
    "pitch": "Customers mention Maito in your shared Slack channel and get answers from your docs, with a person close by.",
    "team": "Customer support",
    "industries": ["Software", "Any"],
    "trigger": "ask",
    "steps": [
      "Read the question it was mentioned on",
      "Answer from docs and past threads",
      "Tag a person when unsure"
    ],
    "example_ask": "@Maito how do I export a report to CSV?",
    "maito": {
      "connect": [{ "need": "docs", "servers": ["Notion", "Confluence (Atlassian)", "Box"] }],
      "skill": []
    }
  },
  {
    "id": "CS01",
    "slug": "flag-accounts-at-risk-of-leaving",
    "title": "Flag accounts at risk of leaving",
    "pitch": "Get a weekly list of customers showing signs of churn, with the reason for each.",
    "team": "Customer success",
    "industries": ["Software", "Any"],
    "trigger": "schedule",
    "steps": [
      "Check usage trend, tickets, replies and renewal date",
      "Flag accounts with warning signs",
      "Say why each is flagged"
    ],
    "example_ask": "Every Monday, tell me which accounts look at risk.",
    "maito": {
      "connect": [
        { "need": "analytics", "servers": ["Amplitude", "Mixpanel", "PostHog"] },
        {
          "need": "support desk",
          "servers": ["Intercom", "Pylon", "Zoho Desk", "Unthread", "Freshdesk"]
        },
        { "need": "CRM", "servers": ["HubSpot", "Salesforce", "Attio", "Pipedrive"] },
        { "need": "billing", "servers": ["Stripe", "PayPal"] }
      ],
      "skill": []
    }
  },
  {
    "id": "CS02",
    "slug": "prep-a-quarterly-business-review",
    "title": "Prep a quarterly business review",
    "pitch": "Get the QBR deck drafted from usage, tickets and goals.",
    "team": "Customer success",
    "industries": ["Software", "Any"],
    "trigger": "ask",
    "steps": [
      "Pull six months of usage, tickets and billing",
      "Compare with the customer's goals",
      "Draft slides and talking points"
    ],
    "example_ask": "Prep the QBR for Acme.",
    "maito": {
      "connect": [
        { "need": "analytics", "servers": ["Amplitude", "Mixpanel", "PostHog"] },
        {
          "need": "support desk",
          "servers": ["Intercom", "Pylon", "Zoho Desk", "Unthread", "Freshdesk"]
        },
        { "need": "CRM", "servers": ["HubSpot", "Salesforce", "Attio", "Pipedrive"] },
        { "need": "billing", "servers": ["Stripe", "PayPal"] }
      ],
      "skill": []
    }
  },
  {
    "id": "CS03",
    "slug": "write-a-one-page-account-plan",
    "title": "Write a one-page account plan",
    "pitch": "Goals, blockers, next steps and renewal date on one page.",
    "team": "Customer success",
    "industries": ["Software", "Any"],
    "trigger": "ask",
    "steps": ["Pull CRM, call notes and tickets", "Draft goals, blockers and actions"],
    "example_ask": "Write an account plan for Globex.",
    "maito": {
      "connect": [
        { "need": "CRM", "servers": ["HubSpot", "Salesforce", "Attio", "Pipedrive"] },
        {
          "need": "call notes",
          "servers": ["Granola", "Fireflies", "Fathom", "Otter.ai", "Read AI", "Zoom"]
        }
      ],
      "skill": []
    }
  },
  {
    "id": "CS04",
    "slug": "run-onboarding-check-ins",
    "title": "Run onboarding check-ins",
    "pitch": "New customers get the right nudge at the right step of onboarding.",
    "team": "Customer success",
    "industries": ["Software", "Any"],
    "trigger": "schedule",
    "steps": [
      "Check each new customer's setup progress",
      "Spot who's stuck",
      "Draft a helpful nudge"
    ],
    "example_ask": "Every day, check new customers' setup and draft nudges for anyone stuck.",
    "maito": {
      "connect": [
        { "need": "analytics", "servers": ["Amplitude", "Mixpanel", "PostHog"] },
        { "need": "email", "servers": ["Gmail", "Microsoft 365", "Superhuman Mail"] },
        { "need": "CRM", "servers": ["HubSpot", "Salesforce", "Attio", "Pipedrive"] }
      ],
      "skill": []
    }
  },
  {
    "id": "CS05",
    "slug": "weekly-update-to-the-customers-executive",
    "title": "Weekly update to the customer's executive",
    "pitch": "Send a short progress note to the customer's sponsor without writing it from scratch.",
    "team": "Customer success",
    "industries": ["Software", "Any"],
    "trigger": "schedule",
    "steps": ["Pull the week's progress and issues", "Draft a short update"],
    "example_ask": "Every Friday, draft an update for Acme's VP.",
    "maito": {
      "connect": [
        { "need": "CRM", "servers": ["HubSpot", "Salesforce", "Attio", "Pipedrive"] },
        {
          "need": "support desk",
          "servers": ["Intercom", "Pylon", "Zoho Desk", "Unthread", "Freshdesk"]
        },
        { "need": "email", "servers": ["Gmail", "Microsoft 365", "Superhuman Mail"] }
      ],
      "skill": []
    }
  },
  {
    "id": "CS06",
    "slug": "catch-the-meaning-of-a-customer-email",
    "title": "Catch the meaning of a customer email",
    "pitch": "Know when a customer is unhappy even when the email is polite.",
    "team": "Customer success",
    "industries": ["Software", "Any"],
    "trigger": "event",
    "steps": [
      "Read incoming customer email",
      "Spot frustration or risk",
      "Alert the CSM with the reason"
    ],
    "example_ask": "Tell me when a customer email sounds unhappy.",
    "maito": {
      "connect": [{ "need": "email", "servers": ["Gmail", "Microsoft 365", "Superhuman Mail"] }],
      "skill": []
    }
  },
  {
    "id": "CS07",
    "slug": "find-expansion-opportunities",
    "title": "Find expansion opportunities",
    "pitch": "Spot accounts that are outgrowing their plan.",
    "team": "Customer success",
    "industries": ["Software", "Any"],
    "trigger": "schedule",
    "steps": [
      "Check usage against plan limits",
      "Find teams that started using the product",
      "List accounts with a reason"
    ],
    "example_ask": "Every month, find accounts ready to upgrade.",
    "maito": {
      "connect": [
        { "need": "analytics", "servers": ["Amplitude", "Mixpanel", "PostHog"] },
        { "need": "billing", "servers": ["Stripe", "PayPal"] },
        { "need": "CRM", "servers": ["HubSpot", "Salesforce", "Attio", "Pipedrive"] }
      ],
      "skill": []
    }
  },
  {
    "id": "CS08",
    "slug": "answer-what-did-we-promise-this-customer",
    "title": "Answer \"what did we promise this customer?\"",
    "pitch": "Find every commitment made to a customer across emails, calls and contracts.",
    "team": "Customer success",
    "industries": ["Software", "Any"],
    "trigger": "ask",
    "steps": [
      "Search emails, call notes and the contract",
      "List each promise with date and who made it"
    ],
    "example_ask": "What did we promise Acme during the sale?",
    "maito": {
      "connect": [
        { "need": "email", "servers": ["Gmail", "Microsoft 365", "Superhuman Mail"] },
        {
          "need": "call notes",
          "servers": ["Granola", "Fireflies", "Fathom", "Otter.ai", "Read AI", "Zoom"]
        },
        {
          "need": "files",
          "servers": ["Google Drive", "Box", "Dropbox", "Notion", "Microsoft 365"]
        }
      ],
      "skill": []
    }
  },
  {
    "id": "CS09",
    "slug": "summarize-renewals-coming-up",
    "title": "Summarize renewals coming up",
    "pitch": "See every renewal in the next 90 days with health and risk.",
    "team": "Customer success",
    "industries": ["Software", "Any"],
    "trigger": "schedule",
    "steps": ["List renewals due", "Add health, usage and open issues", "Sort by risk"],
    "example_ask": "On the 1st of each month, list renewals for the next 90 days.",
    "maito": {
      "connect": [
        { "need": "CRM", "servers": ["HubSpot", "Salesforce", "Attio", "Pipedrive"] },
        { "need": "billing", "servers": ["Stripe", "PayPal"] },
        { "need": "analytics", "servers": ["Amplitude", "Mixpanel", "PostHog"] }
      ],
      "skill": []
    }
  },
  {
    "id": "CS10",
    "slug": "turn-a-customer-call-into-actions",
    "title": "Turn a customer call into actions",
    "pitch": "After a customer call, the notes become tasks, a recap and CRM updates.",
    "team": "Customer success",
    "industries": ["Software", "Any"],
    "trigger": "event",
    "steps": ["Read the call notes", "Write a recap", "Create tasks with owners", "Update the CRM"],
    "example_ask": "After my customer calls, send the recap and create tasks.",
    "maito": {
      "connect": [
        {
          "need": "call notes",
          "servers": ["Granola", "Fireflies", "Fathom", "Otter.ai", "Read AI", "Zoom"]
        },
        { "need": "CRM", "servers": ["HubSpot", "Salesforce", "Attio", "Pipedrive"] },
        {
          "need": "task tracker",
          "servers": ["Linear", "Asana", "ClickUp", "Jira (Atlassian)", "Trello"]
        }
      ],
      "skill": []
    }
  },
  {
    "id": "ENG01",
    "slug": "turn-a-ticket-into-a-tested-pull-request",
    "title": "Turn a ticket into a tested pull request",
    "pitch": "Hand over a well-scoped ticket and get back a pull request with tests.",
    "team": "Engineering",
    "industries": ["Software"],
    "trigger": "ask",
    "steps": [
      "Read the ticket and the code",
      "Make the change",
      "Write and run tests",
      "Open a pull request with a summary"
    ],
    "example_ask": "Fix LIN-412: the date picker ignores the user's time zone.",
    "maito": {
      "connect": [{ "need": "issue tracker", "servers": ["Linear", "Jira (Atlassian)", "GitHub"] }],
      "skill": []
    }
  },
  {
    "id": "ENG02",
    "slug": "review-a-teammates-pull-request",
    "title": "Review a teammate's pull request",
    "pitch": "Get a first review that catches bugs and missed cases before a person looks.",
    "team": "Engineering",
    "industries": ["Software"],
    "trigger": "event",
    "steps": [
      "Read the change and the code around it",
      "Look for bugs, missing tests and risky changes",
      "Comment on the pull request"
    ],
    "example_ask": "Review PR 881.",
    "maito": { "connect": [], "skill": [] }
  },
  {
    "id": "ENG03",
    "slug": "check-a-change-for-security-problems",
    "title": "Check a change for security problems",
    "pitch": "Look at a change for injection, leaked secrets and missing permission checks.",
    "team": "Engineering",
    "industries": ["Software"],
    "trigger": "ask",
    "steps": [
      "Read the change",
      "Check for common security mistakes",
      "Report what's risky and how to fix it"
    ],
    "example_ask": "Security-review the new file upload endpoint.",
    "maito": { "connect": [], "skill": [] }
  },
  {
    "id": "ENG04",
    "slug": "write-the-changelog",
    "title": "Write the changelog",
    "pitch": "Twice a week, turn merged pull requests into a changelog people can read.",
    "team": "Engineering",
    "industries": ["Software"],
    "trigger": "schedule",
    "steps": [
      "Read merged pull requests",
      "Group by user-visible change",
      "Write plain release notes"
    ],
    "example_ask": "Every Tuesday and Friday, draft the changelog from merged PRs.",
    "maito": { "connect": [], "skill": [] }
  },
  {
    "id": "ENG05",
    "slug": "nudge-stale-pull-requests",
    "title": "Nudge stale pull requests",
    "pitch": "Pull requests waiting too long get a polite reminder to the right reviewer.",
    "team": "Engineering",
    "industries": ["Software"],
    "trigger": "schedule",
    "steps": ["Find PRs waiting over a day", "Find who should review", "Send a reminder"],
    "example_ask": "Every morning, nudge reviewers on PRs waiting more than a day.",
    "maito": { "connect": [], "skill": [] }
  },
  {
    "id": "ENG06",
    "slug": "file-a-bug-from-a-slack-thread",
    "title": "File a bug from a Slack thread",
    "pitch": "When a bug comes up in chat, mention Maito and it gets filed once, with details and no duplicates.",
    "team": "Engineering",
    "industries": ["Software"],
    "trigger": "ask",
    "steps": [
      "Read the thread it was mentioned in",
      "Pull the details, logs and links",
      "Check for an existing ticket",
      "File a new one or add to the old one"
    ],
    "example_ask": "@Maito file this as a bug.",
    "maito": {
      "connect": [{ "need": "issue tracker", "servers": ["Linear", "Jira (Atlassian)", "GitHub"] }],
      "skill": []
    }
  },
  {
    "id": "ENG07",
    "slug": "draft-the-incident-postmortem",
    "title": "Draft the incident postmortem",
    "pitch": "Turn the incident channel and logs into a postmortem draft.",
    "team": "Engineering",
    "industries": ["Software"],
    "trigger": "ask",
    "steps": [
      "Read the incident channel and timeline",
      "Pull logs and deploys",
      "Draft cause, impact, timeline and follow-ups"
    ],
    "example_ask": "Draft the postmortem for yesterday's outage.",
    "maito": {
      "connect": [{ "need": "logs", "servers": ["Datadog", "Sentry", "New Relic", "Grafana"] }],
      "skill": []
    }
  },
  {
    "id": "ENG08",
    "slug": "investigate-an-error-spike",
    "title": "Investigate an error spike",
    "pitch": "When errors jump, get a first look at the cause before anyone opens a laptop.",
    "team": "Engineering",
    "industries": ["Software"],
    "trigger": "event",
    "steps": [
      "Read the alert",
      "Check recent deploys, logs and errors",
      "Suggest the likely cause and fix"
    ],
    "example_ask": "Errors on checkout just spiked. What happened?",
    "maito": {
      "connect": [
        { "need": "logs", "servers": ["Datadog", "Sentry", "New Relic", "Grafana"] },
        { "need": "error tracker", "servers": ["Sentry", "Datadog"] }
      ],
      "skill": []
    }
  },
  {
    "id": "ENG09",
    "slug": "update-docs-when-the-code-changes",
    "title": "Update docs when the code changes",
    "pitch": "When an API or setting changes, the docs get a matching update.",
    "team": "Engineering",
    "industries": ["Software"],
    "trigger": "event",
    "steps": [
      "Read the change",
      "Find docs that describe it",
      "Draft the doc update in the same PR"
    ],
    "example_ask": "When an API changes, update the API docs.",
    "maito": {
      "connect": [{ "need": "docs", "servers": ["Notion", "Confluence (Atlassian)", "Box"] }],
      "skill": []
    }
  },
  {
    "id": "ENG10",
    "slug": "upgrade-a-dependency",
    "title": "Upgrade a dependency",
    "pitch": "Bump a library, fix what breaks and open a pull request.",
    "team": "Engineering",
    "industries": ["Software"],
    "trigger": "ask",
    "steps": [
      "Read the release notes",
      "Upgrade and fix breaking changes",
      "Run tests",
      "Open a PR"
    ],
    "example_ask": "Upgrade React Router to the latest version.",
    "maito": { "connect": [], "skill": [] }
  },
  {
    "id": "ENG11",
    "slug": "answer-where-is-this-in-the-code",
    "title": "Answer \"where is this in the code?\"",
    "pitch": "New engineers and other teams get answers about the codebase in chat.",
    "team": "Engineering",
    "industries": ["Software"],
    "trigger": "ask",
    "steps": ["Search the code", "Explain how it works with file links"],
    "example_ask": "Where do we send the welcome email?",
    "maito": { "connect": [], "skill": [] }
  },
  {
    "id": "ENG12",
    "slug": "weekly-engineering-digest",
    "title": "Weekly engineering digest",
    "pitch": "What shipped, what's stuck and what broke, in one message for the team.",
    "team": "Engineering",
    "industries": ["Software"],
    "trigger": "schedule",
    "steps": ["Read merged PRs, open PRs and incidents", "Summarize shipped, blocked and broken"],
    "example_ask": "Every Friday, send the engineering digest.",
    "maito": {
      "connect": [{ "need": "issue tracker", "servers": ["Linear", "Jira (Atlassian)", "GitHub"] }],
      "skill": []
    }
  },
  {
    "id": "ENG13",
    "slug": "clean-up-flaky-tests",
    "title": "Clean up flaky tests",
    "pitch": "Find tests that fail at random and fix or quarantine them.",
    "team": "Engineering",
    "industries": ["Software"],
    "trigger": "schedule",
    "steps": [
      "Read recent test runs",
      "Find tests that pass and fail on the same code",
      "Fix or propose quarantine"
    ],
    "example_ask": "Every week, find flaky tests and fix what you can.",
    "maito": { "connect": [], "skill": [] }
  },
  {
    "id": "ENG14",
    "slug": "write-a-technical-design-draft",
    "title": "Write a technical design draft",
    "pitch": "Turn a feature idea into a design doc that fits how the code works today.",
    "team": "Engineering",
    "industries": ["Software"],
    "trigger": "ask",
    "steps": ["Read the request and the relevant code", "Draft the approach, changes and risks"],
    "example_ask": "Draft a design for adding team-level permissions.",
    "maito": { "connect": [], "skill": [] }
  },
  {
    "id": "QA01",
    "slug": "test-a-branch-in-a-real-browser-before-merge",
    "title": "Test a branch in a real browser before merge",
    "pitch": "Every change gets clicked through in a real browser, with a video.",
    "team": "QA",
    "industries": ["Software"],
    "trigger": "event",
    "steps": [
      "Start the app at the branch",
      "Run the user flows the change touches",
      "Record a video and report problems"
    ],
    "example_ask": "Test PR 881 in the browser.",
    "maito": { "connect": [], "skill": [] }
  },
  {
    "id": "QA02",
    "slug": "nightly-regression-run",
    "title": "Nightly regression run",
    "pitch": "Your key flows get tested every night, with a report in the morning.",
    "team": "QA",
    "industries": ["Software"],
    "trigger": "schedule",
    "steps": [
      "Each night, run the main flows",
      "Compare with the last good run",
      "Report what changed"
    ],
    "example_ask": "Every night, test signup, checkout and export.",
    "maito": { "connect": [], "skill": [] }
  },
  {
    "id": "QA03",
    "slug": "reproduce-a-reported-bug-against-the-last-release",
    "title": "Reproduce a reported bug against the last release",
    "pitch": "Check whether a bug is new, old, or already fixed.",
    "team": "QA",
    "industries": ["Software"],
    "trigger": "ask",
    "steps": ["Run the bug steps on current and previous versions", "Report where it started"],
    "example_ask": "Did the login bug exist in last week's release?",
    "maito": { "connect": [], "skill": [] }
  },
  {
    "id": "QA04",
    "slug": "write-test-cases-from-a-spec",
    "title": "Write test cases from a spec",
    "pitch": "Turn a feature spec into a checklist of test cases, including edge cases.",
    "team": "QA",
    "industries": ["Software"],
    "trigger": "ask",
    "steps": ["Read the spec", "List normal, edge and error cases"],
    "example_ask": "Write test cases for the new invite flow.",
    "maito": {
      "connect": [
        {
          "need": "files",
          "servers": ["Google Drive", "Box", "Dropbox", "Notion", "Microsoft 365"]
        }
      ],
      "skill": []
    }
  },
  {
    "id": "QA05",
    "slug": "check-the-site-on-many-screen-sizes",
    "title": "Check the site on many screen sizes",
    "pitch": "See how key pages look on phones, tablets and wide screens.",
    "team": "QA",
    "industries": ["Software"],
    "trigger": "ask",
    "steps": ["Open pages at common sizes", "Take screenshots", "Point out layout problems"],
    "example_ask": "Check the pricing page on mobile and tablet.",
    "maito": { "connect": [], "skill": [] }
  },
  {
    "id": "QA06",
    "slug": "check-for-broken-links-and-pages",
    "title": "Check for broken links and pages",
    "pitch": "Crawl your site and docs for broken links, missing images and errors.",
    "team": "QA",
    "industries": ["Software"],
    "trigger": "schedule",
    "steps": [
      "Crawl the site",
      "Check every link and image",
      "Report problems with where they are"
    ],
    "example_ask": "Every week, check the docs site for broken links.",
    "maito": { "connect": [], "skill": [] }
  },
  {
    "id": "PRD01",
    "slug": "answer-what-happens-if-we-change-x",
    "title": "Answer \"what happens if we change X?\"",
    "pitch": "Know what a change would touch before you put it on the roadmap.",
    "team": "Product",
    "industries": ["Software"],
    "trigger": "ask",
    "steps": [
      "Read the question",
      "Trace the code and data involved",
      "List what would be affected"
    ],
    "example_ask": "What breaks if we let users have two emails?",
    "maito": { "connect": [], "skill": [] }
  },
  {
    "id": "PRD02",
    "slug": "write-a-spec-with-the-edge-cases",
    "title": "Write a spec with the edge cases",
    "pitch": "Turn a feature idea into a spec that includes the cases the code already handles.",
    "team": "Product",
    "industries": ["Software"],
    "trigger": "ask",
    "steps": [
      "Read the idea",
      "Check the current product behavior",
      "Draft goals, flows, edge cases and open questions"
    ],
    "example_ask": "Write a spec for archiving projects.",
    "maito": {
      "connect": [{ "need": "docs", "servers": ["Notion", "Confluence (Atlassian)", "Box"] }],
      "skill": []
    }
  },
  {
    "id": "PRD03",
    "slug": "build-a-quick-prototype",
    "title": "Build a quick prototype",
    "pitch": "See an idea working on a branch before committing the team to it.",
    "team": "Product",
    "industries": ["Software"],
    "trigger": "ask",
    "steps": ["Read the idea", "Build a rough version on a branch", "Share a preview and a video"],
    "example_ask": "Prototype a dark mode toggle in settings.",
    "maito": { "connect": [], "skill": [] }
  },
  {
    "id": "PRD04",
    "slug": "group-user-feedback-into-themes",
    "title": "Group user feedback into themes",
    "pitch": "See what users ask for most, with counts and quotes.",
    "team": "Product",
    "industries": ["Software"],
    "trigger": "schedule",
    "steps": [
      "Read feedback from tickets, calls, surveys and chat",
      "Group and count",
      "Link examples"
    ],
    "example_ask": "Every Monday, send me the top feedback themes.",
    "maito": {
      "connect": [
        {
          "need": "support desk",
          "servers": ["Intercom", "Pylon", "Zoho Desk", "Unthread", "Freshdesk"]
        },
        {
          "need": "call notes",
          "servers": ["Granola", "Fireflies", "Fathom", "Otter.ai", "Read AI", "Zoom"]
        },
        { "need": "survey tool", "servers": ["SurveyMonkey"] }
      ],
      "skill": []
    }
  },
  {
    "id": "PRD05",
    "slug": "investigate-a-drop-in-a-metric",
    "title": "Investigate a drop in a metric",
    "pitch": "When sign-ups or activation drop, get a first answer on why.",
    "team": "Product",
    "industries": ["Software"],
    "trigger": "ask",
    "steps": [
      "Pull the metric over time",
      "Check releases, campaigns and errors around the drop",
      "Suggest the likely cause"
    ],
    "example_ask": "Why did activation drop last week?",
    "maito": {
      "connect": [
        { "need": "analytics", "servers": ["Amplitude", "Mixpanel", "PostHog"] },
        { "need": "logs", "servers": ["Datadog", "Sentry", "New Relic", "Grafana"] }
      ],
      "skill": []
    }
  },
  {
    "id": "PRD06",
    "slug": "write-release-notes-customers-will-read",
    "title": "Write release notes customers will read",
    "pitch": "Turn the engineering changelog into plain notes for customers.",
    "team": "Product",
    "industries": ["Software"],
    "trigger": "event",
    "steps": ["Read what shipped", "Pick what users notice", "Write short plain notes"],
    "example_ask": "Write customer release notes for this week.",
    "maito": { "connect": [], "skill": [] }
  },
  {
    "id": "PRD07",
    "slug": "prep-for-a-customer-interview",
    "title": "Prep for a customer interview",
    "pitch": "Know the customer's usage and history before the interview.",
    "team": "Product",
    "industries": ["Software"],
    "trigger": "ask",
    "steps": ["Pull usage, tickets and CRM notes", "Draft questions based on the research goal"],
    "example_ask": "Prep me for the interview with Acme on reporting.",
    "maito": {
      "connect": [
        { "need": "analytics", "servers": ["Amplitude", "Mixpanel", "PostHog"] },
        {
          "need": "support desk",
          "servers": ["Intercom", "Pylon", "Zoho Desk", "Unthread", "Freshdesk"]
        },
        { "need": "CRM", "servers": ["HubSpot", "Salesforce", "Attio", "Pipedrive"] }
      ],
      "skill": []
    }
  },
  {
    "id": "PRD08",
    "slug": "summarize-user-interviews",
    "title": "Summarize user interviews",
    "pitch": "Turn interview recordings into findings with quotes.",
    "team": "Product",
    "industries": ["Software"],
    "trigger": "ask",
    "steps": [
      "Read the transcripts",
      "Pull pains, workarounds and quotes",
      "Group across interviews"
    ],
    "example_ask": "Summarize these 8 interviews about onboarding.",
    "maito": {
      "connect": [
        {
          "need": "files",
          "servers": ["Google Drive", "Box", "Dropbox", "Notion", "Microsoft 365"]
        }
      ],
      "skill": []
    }
  },
  {
    "id": "PRD09",
    "slug": "check-how-competitors-do-a-feature",
    "title": "Check how competitors do a feature",
    "pitch": "See how other products handle the feature you're about to build.",
    "team": "Product",
    "industries": ["Software"],
    "trigger": "ask",
    "steps": ["Read competitor docs and pages", "Compare flows, limits and pricing"],
    "example_ask": "How do competitors handle team permissions?",
    "maito": { "connect": [], "skill": [] }
  },
  {
    "id": "PRD10",
    "slug": "keep-the-roadmap-status-current",
    "title": "Keep the roadmap status current",
    "pitch": "Roadmap items get their status from the real work, not from memory.",
    "team": "Product",
    "industries": ["Software"],
    "trigger": "schedule",
    "steps": [
      "Read the roadmap items",
      "Check linked tickets and PRs",
      "Update status and flag slipping items"
    ],
    "example_ask": "Every Friday, update roadmap status from Linear.",
    "maito": {
      "connect": [
        { "need": "issue tracker", "servers": ["Linear", "Jira (Atlassian)", "GitHub"] },
        { "need": "docs", "servers": ["Notion", "Confluence (Atlassian)", "Box"] }
      ],
      "skill": []
    }
  },
  {
    "id": "PRD11",
    "slug": "answer-product-questions-from-sales-and-support",
    "title": "Answer product questions from sales and support",
    "pitch": "Other teams get product answers without waiting for a PM.",
    "team": "Product",
    "industries": ["Software"],
    "trigger": "ask",
    "steps": ["Read the question", "Check docs and code", "Answer and link the source"],
    "example_ask": "Can a viewer export a report?",
    "maito": {
      "connect": [{ "need": "docs", "servers": ["Notion", "Confluence (Atlassian)", "Box"] }],
      "skill": []
    }
  },
  {
    "id": "PRD12",
    "slug": "write-the-weekly-product-update",
    "title": "Write the weekly product update",
    "pitch": "One message for the company on what product shipped and what's next.",
    "team": "Product",
    "industries": ["Software"],
    "trigger": "schedule",
    "steps": ["Read what shipped and what's in progress", "Draft a short update"],
    "example_ask": "Every Friday, draft the product update for #general.",
    "maito": {
      "connect": [{ "need": "issue tracker", "servers": ["Linear", "Jira (Atlassian)", "GitHub"] }],
      "skill": []
    }
  },
  {
    "id": "DAT01",
    "slug": "answer-data-questions-in-slack",
    "title": "Answer data questions in Slack",
    "pitch": "Ask a question in plain words and get the number, with the query behind it.",
    "team": "Data",
    "industries": ["Any"],
    "trigger": "ask",
    "steps": ["Read the question", "Write and run the query", "Answer with the number and a chart"],
    "example_ask": "How many teams signed up last month from Germany?",
    "maito": {
      "connect": [{ "need": "database", "servers": ["BigQuery", "Supabase"] }],
      "skill": []
    }
  },
  {
    "id": "DAT02",
    "slug": "chart-a-metric",
    "title": "Chart a metric",
    "pitch": "Get a chart of any metric over time, ready to paste into a deck.",
    "team": "Data",
    "industries": ["Any"],
    "trigger": "ask",
    "steps": ["Pull the data", "Make a clean chart"],
    "example_ask": "Chart weekly active users for the last 6 months.",
    "maito": {
      "connect": [{ "need": "database", "servers": ["BigQuery", "Supabase"] }],
      "skill": []
    }
  },
  {
    "id": "DAT03",
    "slug": "explain-a-dashboard-number",
    "title": "Explain a dashboard number",
    "pitch": "Know what a number means and how it's calculated.",
    "team": "Data",
    "industries": ["Any"],
    "trigger": "ask",
    "steps": ["Find the metric definition and query", "Explain in plain words"],
    "example_ask": "How is 'active customer' calculated?",
    "maito": {
      "connect": [
        { "need": "database", "servers": ["BigQuery", "Supabase"] },
        { "need": "docs", "servers": ["Notion", "Confluence (Atlassian)", "Box"] }
      ],
      "skill": []
    }
  },
  {
    "id": "DAT04",
    "slug": "check-data-for-problems",
    "title": "Check data for problems",
    "pitch": "Spot missing data, duplicates and sudden jumps before anyone trusts a bad number.",
    "team": "Data",
    "industries": ["Any"],
    "trigger": "schedule",
    "steps": ["Check key tables each day", "Flag missing rows, duplicates and odd jumps"],
    "example_ask": "Every morning, check yesterday's data loads.",
    "maito": {
      "connect": [{ "need": "database", "servers": ["BigQuery", "Supabase"] }],
      "skill": []
    }
  },
  {
    "id": "DAT05",
    "slug": "write-and-fix-sql",
    "title": "Write and fix SQL",
    "pitch": "Get a working query from a description, or fix a broken one.",
    "team": "Data",
    "industries": ["Any"],
    "trigger": "ask",
    "steps": ["Read the request and schema", "Write or fix the query", "Explain it"],
    "example_ask": "Fix this query; it double counts orders.",
    "maito": {
      "connect": [{ "need": "database", "servers": ["BigQuery", "Supabase"] }],
      "skill": []
    }
  },
  {
    "id": "DAT06",
    "slug": "send-a-weekly-metrics-digest",
    "title": "Send a weekly metrics digest",
    "pitch": "Key numbers for the company every Monday, with what changed and why.",
    "team": "Data",
    "industries": ["Any"],
    "trigger": "schedule",
    "steps": ["Pull key metrics", "Compare with last week", "Explain big changes"],
    "example_ask": "Every Monday, post the key metrics to #leadership.",
    "maito": {
      "connect": [
        { "need": "database", "servers": ["BigQuery", "Supabase"] },
        { "need": "billing", "servers": ["Stripe", "PayPal"] }
      ],
      "skill": []
    }
  },
  {
    "id": "IT01",
    "slug": "answer-it-questions-in-the-help-channel",
    "title": "Answer IT questions in the help channel",
    "pitch": "People get answers to everyday IT questions without a ticket.",
    "team": "IT and admin",
    "industries": ["Any"],
    "trigger": "ask",
    "steps": [
      "Read the question",
      "Answer from IT guides",
      "Open a ticket when a person is needed"
    ],
    "example_ask": "How do I set up the VPN on a new laptop?",
    "maito": { "connect": [], "skill": [] }
  },
  {
    "id": "IT02",
    "slug": "handle-access-requests",
    "title": "Handle access requests",
    "pitch": "Access requests get collected, approved by the right person and logged.",
    "team": "IT and admin",
    "industries": ["Any"],
    "trigger": "ask",
    "steps": ["Read the request", "Ask the right approver", "Create the ticket for IT", "Log it"],
    "example_ask": "@Maito I need access to the finance folder.",
    "maito": {
      "connect": [
        {
          "need": "ticketing",
          "servers": ["Jira Service Management (Atlassian)", "ServiceNow", "Freshdesk"]
        }
      ],
      "skill": []
    }
  },
  {
    "id": "IT03",
    "slug": "review-who-has-access",
    "title": "Review who has access",
    "pitch": "Every quarter, check who has access to key tools and flag what looks wrong.",
    "team": "IT and admin",
    "industries": ["Any"],
    "trigger": "schedule",
    "steps": [
      "Pull user lists from key tools",
      "Compare with the HR list",
      "Flag leavers and odd access"
    ],
    "example_ask": "Every quarter, check access to our main tools.",
    "maito": {
      "connect": [],
      "skill": [
        { "need": "admin consoles", "examples": [] },
        { "need": "HR system", "examples": ["BambooHR (private beta)", "Gusto"] }
      ]
    }
  },
  {
    "id": "IT04",
    "slug": "guide-people-through-buying-something",
    "title": "Guide people through buying something",
    "pitch": "Purchases follow the process without people learning it first.",
    "team": "IT and admin",
    "industries": ["Any"],
    "trigger": "ask",
    "steps": [
      "Ask what they want to buy",
      "Explain the steps for that amount and type",
      "Start the request"
    ],
    "example_ask": "I want to buy a new design tool for the team.",
    "maito": { "connect": [], "skill": [] }
  },
  {
    "id": "IT05",
    "slug": "check-a-new-vendors-security",
    "title": "Check a new vendor's security",
    "pitch": "Get a first pass on a vendor's security docs before you sign.",
    "team": "IT and admin",
    "industries": ["Any"],
    "trigger": "ask",
    "steps": [
      "Read their security page and reports",
      "Check against your requirements",
      "List gaps"
    ],
    "example_ask": "Check this vendor's security for our standards.",
    "maito": {
      "connect": [
        {
          "need": "files",
          "servers": ["Google Drive", "Box", "Dropbox", "Notion", "Microsoft 365"]
        }
      ],
      "skill": []
    }
  },
  {
    "id": "IT06",
    "slug": "track-laptops-and-equipment",
    "title": "Track laptops and equipment",
    "pitch": "Know who has which device and when warranties end.",
    "team": "IT and admin",
    "industries": ["Any"],
    "trigger": "schedule",
    "steps": ["Compare device list with people", "Flag missing or expiring", "Remind owners"],
    "example_ask": "Every month, check the equipment list against the team.",
    "maito": {
      "connect": [{ "need": "spreadsheet", "servers": ["Airtable", "Microsoft 365"] }],
      "skill": [{ "need": "HR system", "examples": ["BambooHR (private beta)", "Gusto"] }]
    }
  },
  {
    "id": "IT07",
    "slug": "write-it-how-to-guides",
    "title": "Write IT how-to guides",
    "pitch": "Turn solved IT tickets into short guides.",
    "team": "IT and admin",
    "industries": ["Any"],
    "trigger": "ask",
    "steps": ["Read the ticket", "Write the steps as a guide"],
    "example_ask": "Turn this printer ticket into a guide.",
    "maito": {
      "connect": [
        {
          "need": "ticketing",
          "servers": ["Jira Service Management (Atlassian)", "ServiceNow", "Freshdesk"]
        },
        { "need": "docs", "servers": ["Notion", "Confluence (Atlassian)", "Box"] }
      ],
      "skill": []
    }
  },
  {
    "id": "IT08",
    "slug": "analyze-it-tickets-for-patterns",
    "title": "Analyze IT tickets for patterns",
    "pitch": "See which problems come up most, so you fix them for good.",
    "team": "IT and admin",
    "industries": ["Any"],
    "trigger": "schedule",
    "steps": ["Read the month's tickets", "Group by cause", "Suggest fixes or guides"],
    "example_ask": "Every month, tell me what IT tickets are most common.",
    "maito": {
      "connect": [
        {
          "need": "ticketing",
          "servers": ["Jira Service Management (Atlassian)", "ServiceNow", "Freshdesk"]
        }
      ],
      "skill": []
    }
  },
  {
    "id": "IT09",
    "slug": "troubleshoot-with-your-runbooks",
    "title": "Troubleshoot with your runbooks",
    "pitch": "Admins get step-by-step help that follows your documented procedures.",
    "team": "IT and admin",
    "industries": ["Any"],
    "trigger": "ask",
    "steps": ["Read the problem", "Find the matching runbook", "Walk through the steps"],
    "example_ask": "Email isn't sending from our domain. What do I check?",
    "maito": { "connect": [], "skill": [] }
  },
  {
    "id": "IT10",
    "slug": "watch-for-outages-in-your-tools",
    "title": "Watch for outages in your tools",
    "pitch": "Hear when a tool your team depends on is down, before people ask.",
    "team": "IT and admin",
    "industries": ["Any"],
    "trigger": "schedule",
    "steps": ["Check status pages of your tools", "Post when something is down and when it's back"],
    "example_ask": "Watch the status of our 10 main tools.",
    "maito": { "connect": [], "skill": [] }
  },
  {
    "id": "LEAD01",
    "slug": "catch-me-up-on-everything-i-missed",
    "title": "Catch me up on everything I missed",
    "pitch": "Back from a trip or a day of meetings, get one summary of what needs you.",
    "team": "Founders and leadership",
    "industries": ["Any"],
    "trigger": "ask",
    "steps": [
      "Read channels, email and docs since a time",
      "Pick what needs you",
      "Summarize the rest"
    ],
    "example_ask": "Catch me up on the last 3 days.",
    "maito": {
      "connect": [
        { "need": "email", "servers": ["Gmail", "Microsoft 365", "Superhuman Mail"] },
        { "need": "docs", "servers": ["Notion", "Confluence (Atlassian)", "Box"] }
      ],
      "skill": []
    }
  },
  {
    "id": "LEAD02",
    "slug": "plan-my-week",
    "title": "Plan my week",
    "pitch": "Turn your calendar, inbox and tasks into a plan for the week.",
    "team": "Founders and leadership",
    "industries": ["Any"],
    "trigger": "schedule",
    "steps": [
      "Read calendar, open tasks and inbox",
      "Flag conflicts and deadlines",
      "Suggest priorities"
    ],
    "example_ask": "Every Monday at 7, plan my week.",
    "maito": {
      "connect": [
        {
          "need": "calendar",
          "servers": ["Google Calendar", "Microsoft 365", "Cal.com", "Calendly"]
        },
        { "need": "email", "servers": ["Gmail", "Microsoft 365", "Superhuman Mail"] },
        {
          "need": "task tracker",
          "servers": ["Linear", "Asana", "ClickUp", "Jira (Atlassian)", "Trello"]
        }
      ],
      "skill": []
    }
  },
  {
    "id": "LEAD03",
    "slug": "triage-my-inbox",
    "title": "Triage my inbox",
    "pitch": "Your inbox sorted into reply now, read later and ignore, with drafts ready.",
    "team": "Founders and leadership",
    "industries": ["Any"],
    "trigger": "schedule",
    "steps": [
      "Read new email",
      "Sort by what it needs from you",
      "Draft replies for the easy ones"
    ],
    "example_ask": "Twice a day, sort my inbox and draft replies.",
    "maito": {
      "connect": [{ "need": "email", "servers": ["Gmail", "Microsoft 365", "Superhuman Mail"] }],
      "skill": []
    }
  },
  {
    "id": "LEAD04",
    "slug": "write-the-investor-update",
    "title": "Write the investor update",
    "pitch": "Get the monthly investor update drafted from real numbers and news.",
    "team": "Founders and leadership",
    "industries": ["Any"],
    "trigger": "schedule",
    "steps": ["Pull metrics and finance", "Collect wins and hires", "Draft the update and asks"],
    "example_ask": "On the 3rd of each month, draft the investor update.",
    "maito": {
      "connect": [
        { "need": "billing", "servers": ["Stripe", "PayPal"] },
        { "need": "accounting software", "servers": ["QuickBooks", "Xero"] }
      ],
      "skill": []
    }
  },
  {
    "id": "LEAD05",
    "slug": "prepare-the-board-deck",
    "title": "Prepare the board deck",
    "pitch": "The board deck drafted from the same numbers the team uses.",
    "team": "Founders and leadership",
    "industries": ["Any"],
    "trigger": "ask",
    "steps": ["Pull metrics, finance and plan", "Build slides", "Draft the narrative"],
    "example_ask": "Draft the Q2 board deck.",
    "maito": {
      "connect": [
        { "need": "database", "servers": ["BigQuery", "Supabase"] },
        { "need": "accounting software", "servers": ["QuickBooks", "Xero"] },
        {
          "need": "files",
          "servers": ["Google Drive", "Box", "Dropbox", "Notion", "Microsoft 365"]
        }
      ],
      "skill": []
    }
  },
  {
    "id": "LEAD06",
    "slug": "close-the-loop-after-meetings",
    "title": "Close the loop after meetings",
    "pitch": "After a meeting, notes go out, tasks get created and follow-ups are scheduled.",
    "team": "Founders and leadership",
    "industries": ["Any"],
    "trigger": "event",
    "steps": [
      "Read the notes or transcript",
      "Write decisions and actions",
      "Create tasks",
      "Schedule the follow-up"
    ],
    "example_ask": "After my leadership meetings, send notes and create tasks.",
    "maito": {
      "connect": [
        {
          "need": "call notes",
          "servers": ["Granola", "Fireflies", "Fathom", "Otter.ai", "Read AI", "Zoom"]
        },
        {
          "need": "task tracker",
          "servers": ["Linear", "Asana", "ClickUp", "Jira (Atlassian)", "Trello"]
        },
        {
          "need": "calendar",
          "servers": ["Google Calendar", "Microsoft 365", "Cal.com", "Calendly"]
        }
      ],
      "skill": []
    }
  },
  {
    "id": "LEAD07",
    "slug": "find-a-time-across-calendars",
    "title": "Find a time across calendars",
    "pitch": "Book a meeting across several people and time zones without the email chain.",
    "team": "Founders and leadership",
    "industries": ["Any"],
    "trigger": "ask",
    "steps": ["Check calendars", "Find slots", "Send the invite"],
    "example_ask": "Find an hour next week for me, Dana and the Acme team.",
    "maito": {
      "connect": [
        {
          "need": "calendar",
          "servers": ["Google Calendar", "Microsoft 365", "Cal.com", "Calendly"]
        },
        { "need": "email", "servers": ["Gmail", "Microsoft 365", "Superhuman Mail"] }
      ],
      "skill": []
    }
  },
  {
    "id": "LEAD08",
    "slug": "daily-company-pulse",
    "title": "Daily company pulse",
    "pitch": "One message each morning with the numbers and news that matter.",
    "team": "Founders and leadership",
    "industries": ["Any"],
    "trigger": "schedule",
    "steps": ["Pull key numbers", "Note big changes and escalations", "Post one short message"],
    "example_ask": "Every morning, send me the company pulse.",
    "maito": {
      "connect": [
        { "need": "database", "servers": ["BigQuery", "Supabase"] },
        { "need": "billing", "servers": ["Stripe", "PayPal"] },
        {
          "need": "support desk",
          "servers": ["Intercom", "Pylon", "Zoho Desk", "Unthread", "Freshdesk"]
        }
      ],
      "skill": []
    }
  },
  {
    "id": "LEAD09",
    "slug": "research-a-decision",
    "title": "Research a decision",
    "pitch": "Get a balanced brief on a decision with options, risks and evidence.",
    "team": "Founders and leadership",
    "industries": ["Any"],
    "trigger": "ask",
    "steps": [
      "Read the question",
      "Research options and evidence",
      "Write pros, cons and a recommendation"
    ],
    "example_ask": "Should we open an office in London or stay remote?",
    "maito": { "connect": [], "skill": [] }
  },
  {
    "id": "LEAD10",
    "slug": "track-company-goals",
    "title": "Track company goals",
    "pitch": "Goals get their progress from real data, not from a status meeting.",
    "team": "Founders and leadership",
    "industries": ["Any"],
    "trigger": "schedule",
    "steps": ["Read goals and linked metrics", "Pull progress", "Flag what's off track"],
    "example_ask": "Every two weeks, update our quarterly goals.",
    "maito": {
      "connect": [
        { "need": "database", "servers": ["BigQuery", "Supabase"] },
        { "need": "docs", "servers": ["Notion", "Confluence (Atlassian)", "Box"] }
      ],
      "skill": []
    }
  },
  {
    "id": "LEAD11",
    "slug": "write-the-all-hands-update",
    "title": "Write the all-hands update",
    "pitch": "A draft of the company update from what happened this month.",
    "team": "Founders and leadership",
    "industries": ["Any"],
    "trigger": "schedule",
    "steps": ["Collect wins, numbers and news from teams", "Draft slides and talking points"],
    "example_ask": "Before each all-hands, draft the update.",
    "maito": {
      "connect": [{ "need": "database", "servers": ["BigQuery", "Supabase"] }],
      "skill": []
    }
  },
  {
    "id": "LEAD12",
    "slug": "summarize-a-long-thread-or-doc",
    "title": "Summarize a long thread or doc",
    "pitch": "Get what was decided and what needs you, from any long thread or document.",
    "team": "Founders and leadership",
    "industries": ["Any"],
    "trigger": "ask",
    "steps": ["Read it", "Summarize decisions, open questions and asks"],
    "example_ask": "Summarize this thread.",
    "maito": {
      "connect": [{ "need": "docs", "servers": ["Notion", "Confluence (Atlassian)", "Box"] }],
      "skill": []
    }
  },
  {
    "id": "LEAD13",
    "slug": "find-anything-someone-shared",
    "title": "Find anything someone shared",
    "pitch": "Find a file, link or number someone posted, with its context.",
    "team": "Founders and leadership",
    "industries": ["Any"],
    "trigger": "ask",
    "steps": ["Search messages, files and docs", "Return the item and where it was"],
    "example_ask": "Find the pricing sheet Dana shared last month.",
    "maito": {
      "connect": [
        {
          "need": "files",
          "servers": ["Google Drive", "Box", "Dropbox", "Notion", "Microsoft 365"]
        }
      ],
      "skill": []
    }
  },
  {
    "id": "LEAD14",
    "slug": "prepare-for-a-hard-meeting",
    "title": "Prepare for a hard meeting",
    "pitch": "Get the background, positions and likely questions before a tough meeting.",
    "team": "Founders and leadership",
    "industries": ["Any"],
    "trigger": "ask",
    "steps": [
      "Collect history with the person or company",
      "Summarize positions",
      "List likely questions and answers"
    ],
    "example_ask": "Prep me for the pricing talk with our biggest customer.",
    "maito": {
      "connect": [
        { "need": "CRM", "servers": ["HubSpot", "Salesforce", "Attio", "Pipedrive"] },
        { "need": "email", "servers": ["Gmail", "Microsoft 365", "Superhuman Mail"] },
        {
          "need": "files",
          "servers": ["Google Drive", "Box", "Dropbox", "Notion", "Microsoft 365"]
        }
      ],
      "skill": []
    }
  }
]
